import { render } from "./VuetifyPhoneInput.vue?vue&type=template&id=5fd668d2&scoped=true"
import script from "./VuetifyPhoneInput.vue?vue&type=script&lang=js"
export * from "./VuetifyPhoneInput.vue?vue&type=script&lang=js"

import "./VuetifyPhoneInput.vue?vue&type=style&index=0&id=5fd668d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd668d2"]])

export default __exports__